import { TestIdDomain } from 'constants/testIds';

const LoanFeesTestIdsScope = {
  LOAN_CIC_FEES_FORM: 'loan-cic-fees-form',
  ADJUSTMENTS_TABLE: 'adjustments-table',
  ADJUSTMENTS_ROW: 'adjustments-row',
  FEE_CONTROLS: 'fee-controls',
  EDIT_FEE_TABLE: 'edit-fee-table',
  FEE_ROW: 'fee-row',
  SUB_PROVIDER_DIALOG: 'sub-provider-dialog',
  IMPOUND_ITEM: 'impound-item',
  IMPOUND_LIST: 'impound-list',
  IMPOUND_SECTION: 'impound-section',
  IMPOUND_SCHEDULE: 'impound-schedule',
  INTEREST_CREDIT: 'interest-credit',
  PREPAID_TABLE: 'prepaid-table',
  PREPAID_ROW: 'prepaid-row',
  APPLY_CREDIT: 'apply-credit',
  APR_INDICATOR: 'apr-indicator',
  FEES_UNSAVED: 'fees-unsaved',
  CIC_REASON: 'cic-reason',
  NOTE_SECTION: 'note-section',
  APPRAISAL_SURCHARGE: 'appraisal-surcharge',
  TOTAL_SECTION: 'total-section',
};

export const LoanFeesTestIds = {
  // CicFeeReasonEditItem
  LOAN_CIC_FEES_FORM_EDIT_CIC_ITEM: `${LoanFeesTestIdsScope.LOAN_CIC_FEES_FORM}.edit-cic-item`,

  // DeleteReasonForm
  DELETE_CIC_REASON_MODAL_CONTENT: 'delete-cic-reason-modal.content',
  DELETE_CIC_REASON_INPUT: 'delete-cic-reason-modal.reason-input',

  // FeeTable
  FEE_TABLE: `${TestIdDomain.LOAN_FEES}.fee-table`,
  APPRAISAL_SURCHARGE_INFO_ICON: `${LoanFeesTestIdsScope.APPRAISAL_SURCHARGE}.info-icon`,

  // FeeRecommendationsPanel
  FEE_RECOMMENDATIONS_PANEL: `${TestIdDomain.LOAN_FEES}.fee-recommendations`,
  FEE_RECOMMENDATIONS_ACCEPT_ALL: `${TestIdDomain.LOAN_FEES}.fee-recommendations-accept-all`,
  FEE_RECOMMENDATIONS_REJECT_ALL: `${TestIdDomain.LOAN_FEES}.fee-recommendations-reject-all`,
  FEE_RECOMMENDATIONS_REVIEW_NOTES_INPUT: `${TestIdDomain.LOAN_FEES}.fee-recommendations-review-notes-input`,
  FEE_RECOMMENDATIONS_REJECT_SUBMIT: `${TestIdDomain.LOAN_FEES}.fee-recommendations-reject-submit`,
  FEE_RECOMMENDATIONS_REJECT_CANCEL: `${TestIdDomain.LOAN_FEES}.fee-recommendations-reject-cancel`,
  getFeeRecommendationAcceptId: itemId =>
    `${TestIdDomain.LOAN_FEES}.fee-recommendation-accept-${itemId}`,
  getFeeRecommendationRejectId: itemId =>
    `${TestIdDomain.LOAN_FEES}.fee-recommendation-reject-${itemId}`,
  getFeeRecommendationSourceDocumentId: sessionId =>
    `${TestIdDomain.LOAN_FEES}.fee-recommendation-source-document-${sessionId}`,

  // LoanFeeCicForm
  LOAN_CIC_FEES_FORM: 'loan-cic-fees.form',
  LOAN_CIC_FEES_FORM_SUBMIT_BUTTON: `${LoanFeesTestIdsScope.LOAN_CIC_FEES_FORM}.submit-button`,

  // ManageCICModal
  MANAGE_CIC_MODAL_CONTENT: 'manage-cic-modal.content',

  // LoanFeesBody
  BODY_EDIT_CIC_BUTTON: `${TestIdDomain.LOAN_FEES}.edit-cic-button`,

  // LoanFeesHead
  HEAD_CIC_REASONS_BUTTON: `${TestIdDomain.LOAN_FEES}.cic-reasons-button`,

  // AdjustmentsTable
  ADJUSTMENTS_ADD_BUTTON: `${LoanFeesTestIdsScope.ADJUSTMENTS_TABLE}.add-button`,

  // Controls
  CONTROLS_CANCEL_BUTTON: `${LoanFeesTestIdsScope.FEE_CONTROLS}.cancel-button`,
  CONTROLS_APPLY_CIC_BUTTON: `${LoanFeesTestIdsScope.FEE_CONTROLS}.apply-cic-button`,
  CONTROLS_SAVE_BUTTON: `${LoanFeesTestIdsScope.FEE_CONTROLS}.save-button`,

  // FeeTable (edit)
  EDIT_FEE_TABLE_ADD_BUTTON: `${LoanFeesTestIdsScope.EDIT_FEE_TABLE}.add-button`,

  // SubProviderConfirmDialog
  SUB_PROVIDER_DECLINE_BUTTON: `${LoanFeesTestIdsScope.SUB_PROVIDER_DIALOG}.decline-button`,
  SUB_PROVIDER_CONFIRM_BUTTON: `${LoanFeesTestIdsScope.SUB_PROVIDER_DIALOG}.confirm-button`,

  // ImpoundSection
  IMPOUND_MONTHS_CUSHION_SELECT: `${LoanFeesTestIdsScope.IMPOUND_SECTION}.months-cushion-select`,

  // ImpoundList
  IMPOUND_LIST_ADD_BUTTON: `${LoanFeesTestIdsScope.IMPOUND_LIST}.add-button`,

  // ImpoundScheduleTable modal
  IMPOUND_SCHEDULE_CLOSE_BUTTON: `${LoanFeesTestIdsScope.IMPOUND_SCHEDULE}.close-button`,

  // InterestCredit
  INTEREST_CREDIT_RADIO: `${LoanFeesTestIdsScope.INTEREST_CREDIT}.has-credit-radio`,
  INTEREST_CREDIT_DAYS_INPUT: `${LoanFeesTestIdsScope.INTEREST_CREDIT}.days-input`,

  // PrepaidTable
  PREPAID_TABLE_ADD_BUTTON: `${LoanFeesTestIdsScope.PREPAID_TABLE}.add-button`,

  // ApplyCreditModal
  APPLY_CREDIT_SOURCE_SELECT: `${LoanFeesTestIdsScope.APPLY_CREDIT}.source-select`,

  // AprIndicator
  APR_INDICATOR_BUTTON: `${LoanFeesTestIdsScope.APR_INDICATOR}.info-button`,

  // FeesMoreIcon (unsaved-changes dialog)
  FEES_UNSAVED_DISCARD_BUTTON: `${LoanFeesTestIdsScope.FEES_UNSAVED}.discard-button`,
  FEES_UNSAVED_CONTINUE_BUTTON: `${LoanFeesTestIdsScope.FEES_UNSAVED}.continue-button`,
  FEES_UNSAVED_APPLY_BUTTON: `${LoanFeesTestIdsScope.FEES_UNSAVED}.apply-button`,

  // NoteSection
  NOTE_CANCEL_BUTTON: `${LoanFeesTestIdsScope.NOTE_SECTION}.cancel-button`,
  NOTE_SAVE_BUTTON: `${LoanFeesTestIdsScope.NOTE_SECTION}.save-button`,

  // Dynamic
  getDueDateId: dueDatesFormName => `${dueDatesFormName}.due-date-input`,

  // AdjustmentsTableRow (keyed by adjustmentId)
  getAdjustmentTypeSelectId: id => `${LoanFeesTestIdsScope.ADJUSTMENTS_ROW}.type-select-${id}`,
  getAdjustmentStartDateId: id => `${LoanFeesTestIdsScope.ADJUSTMENTS_ROW}.start-date-${id}`,
  getAdjustmentEndDateId: id => `${LoanFeesTestIdsScope.ADJUSTMENTS_ROW}.end-date-${id}`,
  getAdjustmentDeleteButtonId: id => `${LoanFeesTestIdsScope.ADJUSTMENTS_ROW}.delete-button-${id}`,

  // FeeTableRow (keyed by index / creditId)
  getFeeRecordingTypeSelectId: index =>
    `${LoanFeesTestIdsScope.FEE_ROW}.recording-type-select-${index}`,
  getFeeTypeNameInputId: index => `${LoanFeesTestIdsScope.FEE_ROW}.fee-type-name-input-${index}`,
  getFeeApplyCreditButtonId: index =>
    `${LoanFeesTestIdsScope.FEE_ROW}.apply-credit-button-${index}`,
  getFeeDeleteCreditButtonId: creditId =>
    `${LoanFeesTestIdsScope.FEE_ROW}.delete-credit-button-${creditId}`,
  getFeeTypeSelectId: index => `${LoanFeesTestIdsScope.FEE_ROW}.fee-type-select-${index}`,
  getFeeProviderSelectId: index => `${LoanFeesTestIdsScope.FEE_ROW}.fee-provider-select-${index}`,
  getFeeDeleteButtonId: index => `${LoanFeesTestIdsScope.FEE_ROW}.delete-button-${index}`,

  getTotalSectionSellerAtClosingId: cdSection =>
    `${LoanFeesTestIdsScope.TOTAL_SECTION}.seller-at-closing-amount-${cdSection.toLowerCase()}`,
  getTotalSectionSellerBeforeClosingId: cdSection =>
    `${LoanFeesTestIdsScope.TOTAL_SECTION}.seller-before-closing-amount-${cdSection.toLowerCase()}`,
  getTotalSectionPaidByOthersId: cdSection =>
    `${LoanFeesTestIdsScope.TOTAL_SECTION}.paid-by-others-amount-${cdSection.toLowerCase()}`,

  // ImpoundItem (keyed by index)
  getImpoundTypeSelectId: index =>
    `${LoanFeesTestIdsScope.IMPOUND_ITEM}.impound-type-select-${index}`,
  getImpoundFrequencySelectId: index =>
    `${LoanFeesTestIdsScope.IMPOUND_ITEM}.frequency-select-${index}`,
  getImpoundMonthsSelectId: index => `${LoanFeesTestIdsScope.IMPOUND_ITEM}.months-select-${index}`,
  getImpoundMonthsRevertButtonId: index =>
    `${LoanFeesTestIdsScope.IMPOUND_ITEM}.months-revert-button-${index}`,
  getImpoundDeleteButtonId: index => `${LoanFeesTestIdsScope.IMPOUND_ITEM}.delete-button-${index}`,
  getImpoundAnnualAmountInputId: index =>
    `${LoanFeesTestIdsScope.IMPOUND_ITEM}.annual-amount-input-${index}`,
  getImpoundAmountDueInputId: (index, dueDateIndex) =>
    `${LoanFeesTestIdsScope.IMPOUND_ITEM}.amount-due-input-${index}-${dueDateIndex}`,

  // PrepaidTableRow (keyed by index / feeId)
  getPrepaidFeeTypeNameInputId: index =>
    `${LoanFeesTestIdsScope.PREPAID_ROW}.fee-type-name-input-${index}`,
  getPrepaidFeeTypeSelectId: index =>
    `${LoanFeesTestIdsScope.PREPAID_ROW}.fee-type-select-${index}`,
  getPrepaidFeeProviderSelectId: index =>
    `${LoanFeesTestIdsScope.PREPAID_ROW}.fee-provider-select-${index}`,
  getPrepaidMonthsSelectId: index => `${LoanFeesTestIdsScope.PREPAID_ROW}.months-select-${index}`,
  getPrepaidDeleteButtonId: feeId => `${LoanFeesTestIdsScope.PREPAID_ROW}.delete-button-${feeId}`,

  // CicFeeReasonEditItem (keyed by reasonId)
  getCicReasonDeleteButtonId: reasonId =>
    `${LoanFeesTestIdsScope.CIC_REASON}.delete-button-${reasonId}`,
};
